import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-agricola-product-warning-dialog',
  templateUrl: './agricola-product-warning-dialog.component.html',
  styleUrls: ['./agricola-product-warning-dialog.component.css'],
  standalone: false
})
export class AgricolaProductWarningDialogComponent {

  constructor(private dialogRef: MatDialogRef<AgricolaProductWarningDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
